import styled from '@emotion/styled';
import React from 'react';

import BaseUpgradeModal from './BaseUpgradeModal';
import { assetUrl } from '~/helpers';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { Link } from 'react-router-dom';

const bgImage = assetUrl('assets/images/gifs/upgrade-success.gif');

const ModalContent = styled.div`
  background-image: url(${bgImage});
  min-height: 436px;
`;

export const togglePaymentSuccessModal = (
  modalId: string,
  action: 'open' | 'close'
) => {
  window.dispatchEvent(new Event(`${modalId}::${action}`));
};

type PaymentSuccessModalProps = {
  id: string;
  onContinue?: () => void;
};

const PaymentSuccessModal = ({ id, onContinue }: PaymentSuccessModalProps) => (
  <BaseUpgradeModal
    openEvent={`${id}::open`}
    closeEvent={`${id}::close`}
    maxWidth={680}
    padding={0}
    centered
  >
    <ModalContent className='flex flex-col items-center bg-no-repeat bg-center bg-contain md:bg-auto p-8'>
      <h1 className='text-xl mt-0 mb-4 md:text-2xl md:mb-8 '>
        Upgrade successful!
      </h1>
      <h2 className='flex-1 text-center m-0 text-base md:text-xl'>
        On behalf of the entire Bonjoro team, we thank you for your support ;)
      </h2>
      <div className='flex gap-x-4'>
        <Link to='/billing' target='_blank'>
          <Button
            variant={ButtonVariant.Secondary}
            className='v2-text-neutral-900 !py-2'
          >
            See my settings
          </Button>
        </Link>
        <Button
          variant={ButtonVariant.Primary}
          className='v2-text-neutral-900 !py-2'
          onClick={() =>
            onContinue?.() || togglePaymentSuccessModal(id, 'close')
          }
        >
          Continue
        </Button>
      </div>
    </ModalContent>
  </BaseUpgradeModal>
);

export default PaymentSuccessModal;
